import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem, Link } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { InvoiceAttachmentModel } from '@models/types'

type AttachmentListItemProp = {
  attachment: InvoiceAttachmentModel,
}

const AttachmentListItem = (props: AttachmentListItemProp) => {
  const { attachment } = props
  const url = digObject(attachment, 'links.file_url', '')

  const {
    attachment_file_name,
  } = attachment

  return (
    <DashboardModuleListItem
      isSidebar
      title={attachment_file_name}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        <Link
          greyLink
          href={url}
          target="_blank"
        >
          <FontAwesomeIcon icon={faFileDownload} />
        </Link>
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AttachmentListItem
